<template>
  <section v-if="image" class="capability-band">
    <img class="capability-bg" :src="image" :alt="$t('process.title')">
    <div class="section">
      <p class="eyebrow">{{ $t('process.eyebrow') }}</p><h2>{{ $t('process.title') }}</h2>
      <div class="process"><article v-for="(step,index) in steps" :key="step.title"><span>{{ pad(index) }}</span><h3>{{ step.title }}</h3><p>{{ step.text }}</p></article></div>
      <router-link class="text-link" to="/service">{{ $t('common.service') }} <span>↗</span></router-link>
    </div>
  </section>
  <section v-else class="section">
    <SectionHeading :eyebrow="$t('process.eyebrow')" :title="$t('process.title')" :link="$route.path === '/service' ? '' : '/service'" :link-text="$t('common.service')" />
    <div class="process"><article v-for="(step,index) in steps" :key="step.title"><span>{{ pad(index) }}</span><h3>{{ step.title }}</h3><p>{{ step.text }}</p></article></div>
  </section>
</template>

<script>
import SectionHeading from './SectionHeading.vue'
export default {
  name: 'ProcessSection', components: { SectionHeading }, props: { image: String },
  computed: { steps() { return [1, 2, 3, 4].map(number => ({ title: this.$t(`process.step${number}Title`), text: this.$t(`process.step${number}Text`) })) } },
  methods: { pad(index) { return String(index + 1).padStart(2, '0') } }
}
</script>
